import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./NewTags.module.css";
import Lottie from "lottie-react";
import companyStore from "../../../Store/Store";
import { TextField } from "@mui/material";
import { observer } from "mobx-react";

const NewTags = observer(
  ({ className = "", onClose, isVisible, tags, setTags }) => {
    const navigate = useNavigate();
    const [EmpCode, setEmpCode] = useState("");
    const [location, setLocation] = useState("");
    const [Department, setDepartment] = useState("");
    const [error, setError] = useState({
      IsEmpCodeinvalid: false,
      IsDepartmentinvalid: false,
      IsLocationinvalid: false,
      IsEmpCodeMaxLength: false,
      IsDepartmentMaxLength: false,
      IsLocationMaxLength: false,
    });
    function parseEmpDetails(str) {
      console.log("str", str);

      if (!str || typeof str !== "string") {
        return { Empcode: "", location: "", Department: "" };
      }

      const result = { Empcode: "", location: "", Department: "" };

      // Split by comma
      const pairs = str.split(",");

      for (const pair of pairs) {
        const [key, value] = pair.split(":");

        if (key && value !== undefined) {
          const trimmedKey = key.trim();
          const trimmedValue = value.trim();

          if (trimmedKey === "Empcode") {
            result.Empcode = trimmedValue;
          } else if (trimmedKey === "location") {
            result.location = trimmedValue;
          } else if (trimmedKey === "Department") {
            result.Department = trimmedValue;
          }
        }
      }

      return result;
    }
    useEffect(() => {
      if (companyStore.TagsEmpDetails) {
        let value
        if (typeof (companyStore.TagsEmpDetails) == "object") {
          console.log("this is a object");
          let obj = JSON.parse(JSON.stringify(companyStore.TagsEmpDetails))
          value = {
            Empcode: obj.Empcode,
            location: obj.location,
            Department: obj.Department
          }
        } else {
          console.log("thisis a string");

          value = parseEmpDetails(JSON.parse(JSON.stringify(companyStore.TagsEmpDetails)));
        }

        console.log("value----->>>>>", value);
        if (value.Empcode) {
          setEmpCode(value.Empcode);
        }
        if (value.location) {
          setLocation(value.location);
        }
        if (value.Department) {
          setDepartment(value.Department);
        }
      }
    }, [companyStore.showEmpDetails]);
    function isValidAlphanumericWithSpecials(str) {
      if (str == null) return true;
      if (str.trim() == "") return true;
      if (typeof str !== "string") return false;

      // ^ start, $ end, + one or more
      const regex = /^[a-zA-Z0-9\s\-_\/().]+$/;
      return regex.test(str);
    }
    const GetEmpDetailsAddTags = () => {
      setError({
        IsEmpCodeinvalid: false,
        IsDepartmentinvalid: false,
        IsLocationinvalid: false,
      });
      if (!isValidAlphanumericWithSpecials(EmpCode)) {
        setError((prev) => ({ ...prev, IsEmpCodeinvalid: true }));
        return;
      }
      if (!isValidAlphanumericWithSpecials(Department)) {
        setError((prev) => ({ ...prev, IsDepartmentinvalid: true }));
        return;
      }
      if (!isValidAlphanumericWithSpecials(location)) {
        setError((prev) => ({ ...prev, IsLocationinvalid: true }));
        return;
      }
      const parts = [];

      if (EmpCode != null) parts.push(`Empcode:${EmpCode}`);
      if (location != null) parts.push(`location:${location}`);
      if (Department != null) parts.push(`Department:${Department}`);
      let result
      if (typeof (companyStore.TagsEmpDetails) == "object") {
        result = {
          Empcode: EmpCode,
          location: location,
          Department: Department
        }
      } else {
        result = parts.join(",");
      }
      companyStore.setEmpDetails(result);
      companyStore.setShowEmpDetails(false);
    };
    if (!companyStore.showEmpDetails) return null;
    return (
      <div
        className={[styles.frameParent, className].join(" ")}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={styles.containerNotifi}>
          {/* Heading and Close Icon */}
          <div className={styles.containerheading}>
            <div>Add Employee Details</div>
            <div
              className={styles.containerheadingbtn}
              onClick={() => {
                companyStore.setShowEmpDetails(false);
              }}
            >
              <img
                className={styles.arrowNarrowLeftIcon}
                alt=""
                src="/xclose.svg"
              />
            </div>
          </div>

          {/* sub Heading */}
          <div className={styles.containerSubHeading}>
            Enter employee details below
          </div>
          {/* inner Content */}
          <div className={styles.containerContent}>
            <div className={styles.containerInnerContent}>
              <div>Employee Code</div>
              <div className={styles.containerInnerContentText}>
                <TextField
                  className={styles.mobileMenu32}
                  color="primary"
                  value={EmpCode}
                  type="email"
                  label="Enter employee code"
                  variant="outlined"
                  // required
                  InputProps={{
                    style: {
                      borderRadius: ".75rem",
                    },

                    inputProps: {
                      maxLength: 50, // Enforces max 50 characters
                    },
                  }}
                  onChange={(e) => {
                    setError((prev) => ({
                      ...prev,
                      IsEmpCodeinvalid: false,
                    }));
                    if (e.target.value.length == 50) {
                      setError((prev) => ({
                        ...prev,
                        IsEmpCodeMaxLength: true,
                      }));
                    } else {
                      setError((prev) => ({
                        ...prev,
                        IsEmpCodeMaxLength: false,
                      }));
                    }
                    setEmpCode(e.target.value);
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      minHeight: "56px",
                    },
                    width: "95%",
                  }}
                />
                <div className={styles.errorDiv}>
                  {error.IsEmpCodeMaxLength && (
                    <div className={styles.error}>
                      Maximum allowed character limit is 50.
                    </div>
                  )}
                  {error.IsEmpCodeinvalid && (
                    <div className={styles.error}>
                      Characters like !,@,&,^ etc.are not allowed.
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.containerInnerContent}>
              <div>Employee Department</div>
              <div className={styles.containerInnerContentText}>
                <TextField
                  className={styles.mobileMenu32}
                  color="primary"
                  value={Department}
                  type="email"
                  label="Enter department"
                  variant="outlined"
                  // required
                  InputProps={{
                    style: {
                      borderRadius: ".75rem",
                    },
                    inputProps: {
                      maxLength: 50, // Enforces max 50 characters
                    },
                  }}
                  onChange={(e) => {
                    setError((prev) => ({
                      ...prev,
                      IsDepartmentinvalid: false,
                    }));
                    if (e.target.value.length == 50) {
                      setError((prev) => ({
                        ...prev,
                        IsDepartmentMaxLength: true,
                      }));
                    } else {
                      setError((prev) => ({
                        ...prev,
                        IsDepartmentMaxLength: false,
                      }));
                    }
                    setDepartment(e.target.value);
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      minHeight: "56px",
                    },
                    width: "95%",
                  }}
                />
                <div className={styles.errorDiv}>
                  {error.IsDepartmentMaxLength && (
                    <div className={styles.error}>
                      Maximum allowed character limit is 50.
                    </div>
                  )}
                  {error.IsDepartmentinvalid && (
                    <div className={styles.error}>
                      Characters like !,@,&,^ etc.are not allowed.
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.containerInnerContent}>
              <div>Location</div>
              <div className={styles.containerInnerContentText}>
                <TextField
                  className={styles.mobileMenu32}
                  color="primary"
                  value={location}
                  type="email"
                  label="Enter Location"
                  variant="outlined"
                  // required
                  InputProps={{
                    style: {
                      borderRadius: ".75rem",
                    },
                    inputProps: {
                      maxLength: 50, // Enforces max 50 characters
                    },
                  }}
                  onChange={(e) => {
                    setError((prev) => ({
                      ...prev,
                      IsLocationinvalid: false,
                    }));
                    if (e.target.value.length == 50) {
                      setError((prev) => ({
                        ...prev,
                        IsLocationMaxLength: true,
                      }));
                    } else {
                      setError((prev) => ({
                        ...prev,
                        IsLocationMaxLength: false,
                      }));
                    }
                    setLocation(e.target.value);
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      minHeight: "56px",
                    },
                    width: "95%",
                  }}
                />
                <div className={styles.errorDiv}>
                  {error.IsLocationMaxLength && (
                    <div className={styles.error}>
                      Maximum allowed character limit is 50.
                    </div>
                  )}
                  {error.IsLocationinvalid && (
                    <div className={styles.error}>
                      Characters like !,@,&,^ etc.are not allowed.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* ActionButtons */}
          <div className={styles.containerContentActions}>
            <div className={styles.containerContentContainerActions}>
              <button
                className={styles.containerContentActionsBtnInvert}
                onClick={() => {
                  companyStore.setShowEmpDetails(false);
                }}
              >
                Cancel
              </button>
              <button
                className={styles.containerContentActionsBtn}
                onClick={() => {
                  GetEmpDetailsAddTags();
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  },
);

NewTags.propTypes = {
  className: PropTypes.string,
};

export default NewTags;
